/**
 * UserControl
 * Dropdown with extra options for user
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useApi2, useApi2call } from 'containers/Api2/index.js';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import messages from './messages.js';

function UserControl(props) {
  const { user, dropup, onDelete, setUpdateAvatar, setInviteParentUser, setResetPasswordUser } = props;
  const url = `sa/users/student/${user.id}`;
  const api2call = useApi2call();
  const student = useApi2({ selector: url, version: 2 });
  function handleToggle(on) {
    if (on) {
      api2call({ url, version: 2 });
    }
  }
  return (
    <DropdownButton
      variant="link"
      title={<i className="ss-settings fs-4" />}
      id={`dropdown-user-${user.id}`}
      onToggle={handleToggle}
      className="no-caret d-inline-block"
      direction={dropup ? 'up' : 'down'}
      align="end"
    >
      {user.uniqueId && (
        <Dropdown.Item eventkey="10">
          <span className="text-muted">
            <FormattedMessage {...messages.username} />
            :
            <span className="ms-2 font-monospace">{student.username || '-'}</span>
          </span>
        </Dropdown.Item>
      )}
      <Dropdown.Item eventkey="1" onClick={() => setUpdateAvatar(student)}>
        <FormattedMessage {...messages.updateAvatar} />
      </Dropdown.Item>
      <Dropdown.Item eventkey="2" onClick={() => setInviteParentUser(student)}>
        <FormattedMessage {...messages.inviteParents} />
      </Dropdown.Item>
      {
        user.uniqueId ? (
          <Dropdown.Item eventkey="3" onClick={() => setResetPasswordUser(student)}>
            <FormattedMessage {...messages.resetPassword} />
          </Dropdown.Item>
        ) : (
          <Dropdown.Item eventkey="4" href={`#print/student/student/${user.id}`}>
            <FormattedMessage {...messages.printLetter} />
          </Dropdown.Item>
        )
      }
      <Dropdown.Item eventkey="9">
        <DeleteButton
          className="p-0"
          icon=""
          disabled={!user.canDelete}
          onClick={() => onDelete(user)}
          confirmText={{ ...messages.confirmRemoveMember, values: user }}
        >
          <FormattedMessage {...messages.removeMember} />
        </DeleteButton>
      </Dropdown.Item>
    </DropdownButton>
  );
}

UserControl.propTypes = {
  user: PropTypes.object,
  onDelete: PropTypes.func,
  setUpdateAvatar: PropTypes.func,
  setInviteParentUser: PropTypes.func,
  setResetPasswordUser: PropTypes.func,
  dropup: PropTypes.bool,
};

export default UserControl;
